import classNames from 'classnames';
import React from 'react';

type SvgIconInfo = {
  className?: string;
  name: string;
  color?: string;
  onClick?: (e: React.MouseEvent<HTMLSpanElement>) => void;
  fontSize?: number;
};

const IconFont = function ({ name, color, onClick, fontSize, className = '' }: SvgIconInfo) {
  return (
    <span
      style={{
        color,
        width: `${fontSize}px`,
        height: `${fontSize}px`,
        display: 'block',
        fontSize: `${fontSize}px`,
      }}
      onClick={(e) => {
        if (onClick) {
          onClick(e);
        }
      }}
      className={classNames('iconfont', `icon-${name}`, className)}
    ></span>
  );
};

export default IconFont;
